import { Component } from '@angular/core'
import { SeFeCardModule } from 'se-fe-card'
import { SeFeCardHeaderSkeletonComponent } from 'se-fe-card/skeleton'
import { SeFeListModule } from 'se-fe-list'
import { SeFeListItemSkeletonComponent } from 'se-fe-list/skeleton'

@Component({
  selector: 'se-po-profile-dibs-skeleton',
  standalone: true,
  imports: [SeFeCardModule, SeFeCardHeaderSkeletonComponent, SeFeListModule, SeFeListItemSkeletonComponent],
  template: `
    <se-fe-card>
      <se-fe-card-header-skeleton seFeDataSize="section" [seFeDataHeavyBorder]="true" [seFeDataTitle]="true"></se-fe-card-header-skeleton>
      <se-fe-card-content>
        <se-fe-list>
          <se-fe-list-item-skeleton seFeDataSize="xsmall" [seFeDataSubtitle]="true" [seFeDataTitle]="true"></se-fe-list-item-skeleton>
          <se-fe-list-item-skeleton seFeDataSize="xsmall" [seFeDataSubtitle]="true" [seFeDataTitle]="true"></se-fe-list-item-skeleton>
        </se-fe-list>
      </se-fe-card-content>
    </se-fe-card>
  `,
})
export class ProfileDibsSkeletonComponent {}
